<script setup lang="ts">
import AppTextTooltip from "@/components/common/AppTextTooltip";
import { icPlaceOutline, icRemoteOutline } from "@/components/icons";
import { mdiClose } from "@mdi/js";
import { Button, Icon, useScreenSize } from "@soft-db/ui";

const emit = defineEmits(["close"]);
const props = defineProps({
	objectType: { type: String, required: true },
	title: String,
});

const objectType = computed(() => props.objectType);

const icon = computed(() => {
	switch (objectType.value) {
		case "site":
			return icPlaceOutline;
		case "station":
			return icRemoteOutline;
	}
});

const { mdOrLower } = useScreenSize();
</script>

<template>
	<div class="md:max-w-76 flex items-center justify-between gap-1 pb-1">
		<div class="flex size-10 items-center justify-center md:size-5">
			<Icon class="text-primary" :size="mdOrLower ? 'lg' : 'md'" :d="icon" />
		</div>
		<AppTextTooltip as="h4" :value="title" />
		<Button
			:size="mdOrLower ? 'md' : 'sm'"
			shape="round"
			variant="ghost"
			@click="() => emit('close')"
		>
			<Icon :d="mdiClose" />
		</Button>
	</div>
</template>
